import { RequestError } from '@zoryn/network'
import { ZMessage } from '@zoryn/components/message'

/**
 * HTTP 业务/网络错误已由 createAppRequest.onError 统一提示。
 * 表格 catch 只补非 RequestError 的意外失败，避免同一条接口错误弹两次。
 */
export function notifyUnhandledRequestError(
  error: unknown,
  fallback: string
) {
  if (error instanceof RequestError) return
  ZMessage.error(
    error instanceof Error && error.message ? error.message : fallback
  )
}
